export default __webpack_public_path__ + "static/media/tech-neck-help.3d3e38c1.jpg";